
import React from 'react';
import { Link } from 'react-router-dom';
import FooterLinkGroup from './FooterLinkGroup';
import { Info, Mail, HelpCircle } from 'lucide-react';

const CompanyLinks: React.FC = () => {
  const links = [
    {
      to: "/about",
      label: "About Us",
      icon: <Info className="h-3.5 w-3.5" />
    },
    {
      to: "/contact",
      label: "Contact",
      icon: <Mail className="h-3.5 w-3.5" />
    },
    {
      to: "/faq",
      label: "FAQs",
      icon: <HelpCircle className="h-3.5 w-3.5" />
    }
  ];

  return (
    <FooterLinkGroup title="Company" links={links} />
  );
};

export default CompanyLinks;
